export default __webpack_public_path__ + "static/media/Cross-icon.116cf782.svg";